import { ColorModeContext } from "@contexts";
import { size } from "lodash";
import { useLocale } from "next-intl";
import React, { useContext } from "react";
import { useShopCurrencyValue } from "src/hooks/useShopMarket";
import { localPaymentMarks } from "./local-payment-methods";

/**
 * BLIK and Przelewy24 as small bordered text chips, sized like the 24x16 card
 * logos. currentColor keeps them legible on the light delivery step and on the
 * coloured price bar alike, with no brand assets to licence or keep in sync.
 */
const markStyle: React.CSSProperties = {
  display: "inline-block",
  boxSizing: "border-box",
  height: 16,
  margin: "0 2px",
  padding: "0 4px",
  border: "1px solid currentColor",
  borderRadius: 3,
  fontSize: 10,
  fontWeight: 700,
  lineHeight: "14px",
  letterSpacing: "0.02em",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
};

const CardIcons = ({
  switchMode = true,
  currency: currencyOverride,
}: {
  switchMode?: boolean;
  /** The order's currency where there is an order; the shop's otherwise. */
  currency?: string;
}) => {
  const iconStyle = {
    margin: "0 2px", // Adjust the margin as needed
  };
  const { mode, setMode } = useContext(ColorModeContext);
  const shopCurrency = useShopCurrencyValue();
  const currency = currencyOverride ?? shopCurrency;
  const locale = useLocale();

  return (
    <>
      {localPaymentMarks(currency, locale).map((mark) => (
        <span key={mark} className="BrandIcon" style={markStyle}>
          {mark}
        </span>
      ))}
      <img
        src={"/images/cards/Visa.svg"}
        alt="Visa"
        className="BrandIcon"
        loading="lazy"
        style={iconStyle}
      />
      <img
        src={"/images/cards/MasterCard.svg"}
        alt="MasterCard"
        className="BrandIcon"
        loading="lazy"
        style={iconStyle}
      />
      <img
        src={"/images/cards/Amex.svg"}
        alt="American Express"
        className="BrandIcon"
        loading="lazy"
        style={iconStyle}
      />
      <img
        src={"/images/cards/UnionPay.svg"}
        alt="UnionPay"
        className="BrandIcon"
        loading="lazy"
        style={iconStyle}
      />
      <img
        src={"/images/cards/JCB.svg"}
        alt="JCB"
        className="BrandIcon"
        loading="lazy"
        style={iconStyle}
      />
      <img
        src={"/images/cards/Discover.svg"}
        alt="Discover"
        className="BrandIcon"
        loading="lazy"
        style={iconStyle}
      />
      <img
        src={"/images/cards/Diners.svg"}
        alt="Diners Club"
        className="BrandIcon"
        loading="lazy"
        style={iconStyle}
      />
      <img
        src={
          switchMode && mode === "dark"
            ? "/images/cards/GooglePayLight.svg"
            : "/images/cards/GooglePayDark.svg"
        }
        alt="Google Pay"
        className="BrandIcon"
        loading="lazy"
      />

      <img
        src={
          switchMode && mode === "dark"
            ? "/images/cards/ApplePayLight.png"
            : "/images/cards/ApplePayDark.png"
        }
        alt="Apple Pay"
        className="BrandIcon"
        loading="lazy"
      />

      {/* <img
        src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg"
        alt="Apple Pay"
        className="BrandIcon"
        loading="lazy"
      /> */}
    </>
  );
};

export default CardIcons;
